// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_studio-freight_lenis_dist_lenis_mjs":"540abbaf6338e2c1d227","vendors-node_modules_gsap_index_js":"548a8c67d4d882cb19c9","vendors-node_modules_gsap_ScrollTrigger_js":"3a866e5e0ad94925211b"}[chunkId] + ".js";
};